import logout from "@/util/logout";
import store from "../../store";
import messages from "../../languages/index";
import hasNewCasino from "../../util/hasNewCasino";

const lang = localStorage.getItem("language") || store.state.language || "pt";
const operatorType = localStorage.getItem("operator-retail");
var credit = localStorage.getItem("operator-credit");
const domain = localStorage.getItem("operator");
const operatorHasNewCasino = hasNewCasino.includes(domain);

const operator = {
  operatorType: operatorType,
  credit: credit,
};

// const operator = {
//   operatorType: operatorType,
//   credit: 2,
// };

export default {
  name: "collaborator",
  path: "/collaborator",
  redirect: {
    name: "CollaboratorDashboard"
  },
  meta: {
    requiresAuth: true,
    nameDrawer: "Colaborador"
  },
  component: () => import("@/views/backoffice/template.vue"),
  beforeEnter: (to, from, next) => {
    const { level } = localStorage;
    level == "collaborator" ? next() : logout();
  },
  children: [
    {
      name: "CollaboratorDashboard",
      path: "dashboard",
      drawerLevel: "online",
      meta: {
        nameDrawer: "Dashboard",
        active: true,
        icon: "mdi-view-dashboard",
        group: false,
        operator: true
      },
      component: () =>
        import("@/views/backoffice/collaborator/dashboard/home.vue")
    },

    //  =================================================================
    //  Category: Online
    //  =================================================================

    // Bets
    {
      name: "CollaboratorBets",
      path: "collaboratorBets",
      drawerLevel: "online",
      meta: {
        nameDrawer: `${messages[lang].bets} `,
        icon: "mdi-ticket-account",
        group: operator.casino != "0",
        operator: operator.credit == 2 ? true : false,
        permissions: ["1", "2", "41"]
      },
      component: () => import("@/views/backoffice/collaborator/online/bet"),
      children: [
        // Chart Bets Online
        {
          name: "CollaboratorChartOnline",
          path: "chartOnline",
          meta: {
            nameDrawer: messages[lang].sports,
            operator: operator.credit == 2 ? true : false,
            filters: ["Range", "SelectTypeBet"],
            filterLimitDays: 31,
            permission: "1"
          },
          component: () =>
            import("@/views/backoffice/collaborator/online/bet/chartOnline")
        },
        // List Bets Online
        {
          name: "CollaboratorBetListPlayerOnline",
          path: "listOnline",
          meta: {
            nameDrawer: messages[lang].report,
            operator: false,
            group: false,
            icon: "mdi-ticket-account",
            filters: [
              "Range",
              "AutocompletePlayers",
              "SelectStatusBet",
              "SelectTypeBet",
              "SelectResultBet",
              "Sinal",
              "SinalAward",
              "EventNumber",
              "GroupExport"
            ],
            filterLimitDays: 7,
            permission: "2"
          },
          component: () =>
            import("@/views/backoffice/collaborator/online/bet/listOnline")
        },
        // Casino Online Bets List
        {
          name: "CollaboratorCasinoListBetOnline",
          path: "casinoListBetOnline",
          meta: {
            nameDrawer: messages[lang].casino,
            operator:
              operator.credit == 2 && operatorHasNewCasino ? true : false,
            filters: [
              "Range",
              "SelectCasinoGroupBy",
              "SelectCasinoVerticalCategory",
              "AutocompleteProvidersByOperator",
              "AutocompleteCasinoCategories",
              "SelectCasinoLobby",
              "SelectTypeBetCasino",
            ],
            filterLimitDays: 31,
            permission: "41"
          },
          component: () =>
            import(
              "@/views/backoffice/collaborator/online/bet/newCasinoListBetOnline"
            ),
          beforeEnter: (to, from, next) => {
            const user_data = JSON.parse(localStorage.getItem("user_data"));
            const permissions = user_data.permissions;
            const hasPermission = id =>
              permissions.find(permission => permission.permissions == id);

            if (hasPermission("41")) {
              next();
            } else {
              next("/");
            }
          },
        },
        // New Casino Online Bets List
        {
          name: "CollaboratorNewCasinoListBetOnline",
          path: "newCasinoListBetOnline",
          meta: {
            hide: true,
          },
          redirect: {
            name: "CollaboratorCasinoListBetOnline",
          },
        },
      ]
    },

    // Affiliates
    {
      name: "CollaboratorAffiliates",
      path: "affiliates",
      drawerLevel: "online",
      meta: {
        nameDrawer: messages[lang].affiliates,
        icon: "mdi-account-group",
        group: true,
        operator: operator.credit == 2 ? true : false,
        permissions: [
          "12",
          "13",
          "14",
          "15",
          "16",
          "17",
          "18",
          "19",
          "20",
          "61",
          "105",
          "106",
          "122"
        ]
      },
      component: () =>
        import("@/views/backoffice/collaborator/online/affiliates/"),
      children: [
        {
          name: "CollaboratorAffiliatesReports",
          path: "affiliatesReports",
          redirect: {
            name: "CollaboratorOnlineExtract",
          },
          meta: {
            nameDrawer: messages[lang].reports,
            icon: "mdi-account-group",
            operator: operator.credit == 2 ? true : false,
          },
          component: () =>
            import("@/views/backoffice/collaborator/online/affiliates/"),
          children: [
            // Affiliates Extract
            {
              name: "CollaboratorOnlineExtract",
              path: "extract",
              redirect: {
                name: (() => {
                  const hasPermission = (id) => {
                    const user_data = JSON.parse(localStorage.getItem("user_data"));

                    if (!user_data) {
                      return false;
                    }

                    if (user_data.isCollaborator) {
                      const permissions = user_data.permissions;
                      return permissions.find(
                        (permission) => permission.permissions == id
                      );
                    }

                    return true;
                  };

                  return hasPermission("61")
                    ? "CollaboratorAffiliatesRenevueShare"
                    : "CollaboratorAffiliatesCpa";
                })(),
              },
              meta: {
                nameDrawer: messages[lang].extract,
                filterLimitDays: 31,
                permission: "61"
              },
              component: () =>
                import(
                  "@/views/backoffice/collaborator/online/affiliates/extractAndCpa/"
                ),
              children: [
                {
                  name: "CollaboratorAffiliatesRenevueShare",
                  path: "revenueShare",
                  meta: {
                    nameDrawer: "Revenue Share",
                    filters: ["Range", "GamingType", "GroupExport", "HasInvoice"],
                    filterLimitDays: 31
                  },
                  component: () =>
                    import(
                      "@/views/backoffice/collaborator/online/affiliates/extractAndCpa/extract/"
                    )
                },
                {
                  name: "CollaboratorAffiliatesCpa",
                  path: "cpa",
                  meta: {
                    nameDrawer: "CPA",
                    filters: [
                      "Range",
                      "AutocompleteRegionals",
                      "AutocompleteLocals",
                      "AutocompleteAgents",
                      "HasInvoice",
                      "GroupExport"
                    ],
                    filterLimitDays: 31,
                    permissions: ["12", "13", "14", "122"]
                  },
                  component: () =>
                    import(
                      "@/views/backoffice/collaborator/online/affiliates/extractAndCpa/cpa/"
                    )
                }
              ]
            },

            // Gerentes Regionais
            {
              name: "CollaboratorAffiliatesRegionalManagersList",
              path: "regional-managers/list",
              meta: {
                nameDrawer: messages[lang].regionalManagers,
                operator:
                  operator.operatorType == 1 || operator.operatorType == 2
                    ? true
                    : false,
                filters: ["SelectStatus"]
              },
              component: () =>
                import(
                  "@/views/backoffice/collaborator/online/affiliates/users/regional-managers/list"
                ),
              children: [
                {
                  name: "CollaboratorAffiliatesRegionalManagersCreate",
                  path: "create",
                  meta: {
                    nameDrawer: messages[lang].newRegionalManager
                  },
                  component: () =>
                    import(
                      "@/views/backoffice/collaborator/online/affiliates/users/regional-managers/update"
                    )
                },
                {
                  name: "CollaboratorAffiliatesRegionalManagersEdit",
                  path: "edit/:id",
                  meta: {
                    nameDrawer: messages[lang].editRegionalManager
                  },
                  component: () =>
                    import(
                      "@/views/backoffice/collaborator/online/affiliates/users/regional-managers/update"
                    )
                }
              ]
            },
            // Gerentes Locais
            {
              name: "CollaboratorAffiliatesLocalManagersList",
              path: "local-managers/list",
              meta: {
                nameDrawer: messages[lang].localManagers,
                operator:
                  operator.operatorType == 1 || operator.operatorType == 2
                    ? true
                    : false,
                filters: ["AutocompleteRegionals", "SelectStatus"]
              },
              component: () =>
                import(
                  "@/views/backoffice/collaborator/online/affiliates/users/local-managers/list"
                ),
              children: [
                {
                  name: "CollaboratorAffiliatesUsersLocalManagersCreate",
                  path: "create",
                  meta: {
                    nameDrawer: messages[lang].newLocalManager
                  },
                  component: () =>
                    import(
                      "@/views/backoffice/collaborator/online/affiliates/users/local-managers/update"
                    )
                },
                {
                  name: "CollaboratorAffiliatesUsersLocalManagersEdit",
                  path: "edit/:id",
                  meta: {
                    nameDrawer: messages[lang].editLocalManager
                  },
                  component: () =>
                    import(
                      "@/views/backoffice/collaborator/online/affiliates/users/local-managers/update"
                    )
                }
              ]
            },

            //  Affiliates
            {
              name: "CollaboratorAffiliatesAffiliatesList",
              path: "affiliates/list",
              meta: {
                nameDrawer: messages[lang].affiliates,
                operator:
                  operator.operatorType == 1 || operator.operatorType == 2
                    ? true
                    : false,
                filters: [
                  "AutocompleteRegionals",
                  "AutocompleteLocals",
                  "SelectStatus",
                  "HasInvoice"
                ]
              },
              component: () =>
                import(
                  "@/views/backoffice/collaborator/online/affiliates/users/affiliates/list"
                ),
              children: [
                {
                  name: "CollaboratorAffiliatesUsersAffiliatesCreate",
                  path: "create",
                  meta: {
                    nameDrawer: messages[lang].newAgent
                  },
                  component: () =>
                    import(
                      "@/views/backoffice/collaborator/online/affiliates/users/affiliates/update"
                    )
                },
                {
                  name: "CollaboratorAffiliatesUsersAffiliatesEdit",
                  path: "edit/:id",
                  meta: {
                    nameDrawer: messages[lang].editAgent
                  },
                  component: () =>
                    import(
                      "@/views/backoffice/collaborator/online/affiliates/users/affiliates/update"
                    )
                },
                {
                  name: "CollaboratorAffiliatesUsersAffiliatesAnalyticalReport",
                  path: "report/:id/:name/:status",
                  meta: {
                    nameDrawer: messages[lang].analyticReport,
                    filterLimitDays: 31
                  },
                  component: () =>
                    import(
                      "@/views/backoffice/collaborator/online/affiliates/users/affiliates/AnalyticalReportByAffiliate"
                    ),
                  beforeEnter: (to, from, next) => {
                    const user_data = JSON.parse(localStorage.getItem("user_data"));
                    const permissions = user_data.permissions;
                    const hasPermission = id =>
                      permissions.find(permission => permission.permissions == id);

                    if (hasPermission("95")) {
                      next();
                    } else {
                      next("/");
                    }
                  }
                },
                {
                  name: "CollaboratorAffiliatesUsersLinkExemptPlayerAffiliates",
                  path: "link-exempt-player-affiliates",
                  meta: {
                    nameDrawer: messages[lang].linkExemptPlayerAffiliates,
                  },
                  component: () =>
                    import("@/components/common/dialog/LinkExemptPlayer"),
                },
                {
                  name: "CollaboratorAffiliatesUsersLinkAffiliateExemptPlayer",
                  path: "link-affiliate-exempt-player/:id",
                  meta: {
                    nameDrawer: messages[lang].linkAffiliateExemptPlayer,
                  },
                  component: () =>
                    import("@/components/common/dialog/LinkExemptPlayer"),
                },
              ]
            },
            // Payments
            {
              name: "CollaboratorAffiliatesPayments",
              path: "payments",
              meta: {
                nameDrawer: messages[lang].payments.tab,
                operator: operator.operatorType == 1 || operator.operatorType == 2,
                filters: [
                  "AutocompleteRegionals",
                  "AutocompleteLocals",
                  "PaymentMonth"
                ]
              },
              beforeEnter: (to, from, next) => {
                if (to.name === "CollaboratorAffiliatesPayments") {
                  next("/collaborator/affiliates/affiliatesReports/payments/pay");
                } else {
                  next();
                }
              },
              component: () =>
                import("@/views/backoffice/shared/affiliates/payments/"),
              children: [
                {
                  name: "CollaboratorAffiliatesPaymentsPay",
                  path: "pay",
                  meta: {
                    nameDrawer: messages[lang].payments.pay
                  },
                  component: () =>
                    import("@/views/backoffice/shared/affiliates/payments/pay/")
                },
                {
                  name: "CollaboratorAffiliatesPaymentsHistoric",
                  path: "historic",
                  meta: {
                    nameDrawer: messages[lang].payments.historic
                  },
                  component: () =>
                    import(
                      "@/views/backoffice/shared/affiliates/payments/historic/"
                    )
                }
              ]
            }
          ],
        },
        {
          name: "CollaboratorAffiliatesCampaings",
          path: "affiliatesCampaigns",
          meta: {
            nameDrawer: messages[lang].campaings,
            icon: "mdi-web-check",
            operator: operator.credit == 2 ? true : false,
            filters: [
              "Range",
              "AutocompleteRegionals",
              "AutocompleteLocals",
              "AutocompleteAgents",
              "SelectStatus",
            ],
            filterLimitDays: 31,
            permission: "134",
          },
          component: () =>
            import("@/views/backoffice/shared/campaings/"),
          beforeEnter: (to, from, next) => {
            const user_data = JSON.parse(localStorage.getItem("user_data"));
            const permissions = user_data.permissions;
            const hasPermission = id =>
              permissions.find(permission => permission.permissions == id);

            if (hasPermission("134")) {
              next();
            } else {
              next("/");
            }
          },
        },
      ]
    },

    // Players
    {
      name: "CollaboratorPlayers",
      path: "players",
      drawerLevel: "online",
      meta: {
        nameDrawer: `${messages[lang].players}`,
        icon: "mdi-account",
        operator: operator.credit == 2 ? true : false,
        permissions: [
          "25",
          "26",
          "27",
          "28",
          "29",
          "30",
          "31",
          "32",
          "33",
          "34",
          "35"
        ]
      },
      component: () =>
        import("@/views/backoffice/collaborator/online/users/players/"),
      children: [
        // Players (Jogadores) Online
        {
          name: "CollaboratorAccountabilityOnlinePlayersOnlineSearch",
          path: "playerOnlineSearch",
          meta: {
            nameDrawer: messages[lang].search,
            operator: operator.credit == 2 ? true : false,
            group: false,
            filters: ["AutocompletePlayers"]
          },
          component: () =>
            import(
              "@/views/backoffice/collaborator/online/users/players/searchOnline"
            ),
          children: [
            {
              name: "CollaboratorPlayerOnlinelistBets",
              path: "playerOnlinelistBets",
              meta: {
                nameDrawer: messages[lang].listBets,
                hide: true,
                filters: [
                  "Range",
                  "SelectStatusBet",
                  "SelectResultBet",
                  "Sinal"
                ],
                filterLimitDays: 31
              }
            },
            {
              name: "CollaboratorListCreditsOnline",
              path: "listCreditsOnline",
              meta: {
                nameDrawer: messages[lang].listCredits,
                hide: true,
                filters: ["Range", "GroupStatus"],
                filterLimitDays: 31
              }
            },
            {
              name: "CollaboratorTransferForOnlinePlayer",
              path: "transferForOnlinePlayer",
              meta: {
                nameDrawer: messages[lang].depositForPlayer,
                hide: true,
                filters: [
                  // "Range",
                  // "GroupStatus"
                ],
                filterLimitDays: 31
              }
            },
            {
              name: "CollaboratorOnlinePlayerReleases",
              path: "releasesOnline",
              meta: {
                nameDrawer: messages[lang].releases,
                hide: true,
                filters: [
                  "Range"
                  // "GroupStatus"
                ],
                filterLimitDays: 31
              }
            },
            {
              name: "CollaboratorConfigOnline",
              path: "configOnline",
              meta: {
                nameDrawer: `${messages[lang].configuration} `,
                hide: true
              }
            },
            {
              name: "CollaboratorAnalyticalReportPlayer",
              path: "reportPlayer",
              meta: {
                nameDrawer: `${messages[lang].analyticReport} `,
                filters: ["GroupExport"],
                filterLimitDays: 31
              }
            }
          ]
        },
        // List Players Online
        {
          name: "CollaboratorListPlayersOnline",
          path: "listPlayersOnline",
          meta: {
            nameDrawer: messages[lang].playersList,
            operator: operator.credit == 2 ? true : false,
            filters: [
              "Range",
              "SelectStatusPlayers",
              "Sinal",
              "SinalDeposit",
              "GroupExport"
            ],
            filterLimitDays: 15
          },
          component: () =>
            import(
              "@/views/backoffice/collaborator/online/users/players/listPlayersOnline"
            )
        },
        // List Players Inactive
        {
          name: "CollaboratorPlayersOnlineInactives",
          path: "playersOnlineInactives",
          meta: {
            nameDrawer: messages[lang].inactivePlayers,
            operator: operator.credit == 2 ? true : false
          },
          component: () =>
            import(
              "@/views/backoffice/collaborator/online/users/players/playersOnlineInactives"
            )
        },
        // Total Online Balance
        {
          name: "CollaboratorTotalOnlineBalance",
          path: "totalOnlineBalance",
          meta: {
            nameDrawer: messages[lang].totalOnlineBalance,
            operator: operator.credit == 2
          },
          component: () =>
            import(
              "@/views/backoffice/collaborator/online/users/players/totalOnlineBalance"
            )
        },
        // Verificação de Documento
        {
          name: "CollaboratorDocumentVerification",
          path: "documentVerification",
          meta: {
            nameDrawer: messages[lang].documentVerification,
            operator: operator.credit == 2
          },
          component: () =>
            import(
              "@/views/backoffice/collaborator/online/users/players/documentVerification"
            )
        },
        // Tags Config
        {
          name: "CollaboratorTagsConfig",
          path: "tagsConfig",
          meta: {
            nameDrawer: messages[lang].tagsConfig,
            operator: operator.credit == 2,
          },
          component: () =>
            import(
              "@/views/backoffice/shared/users/players/tagsConfig"
            ),
          beforeEnter: (to, from, next) => {
            const user_data = JSON.parse(localStorage.getItem("user_data"));
            const permissions = user_data.permissions;
            const hasPermission = id =>
              permissions.find(permission => permission.permissions == id);

            if (hasPermission("140")) {
              next();
            } else {
              next("/");
            }
          }
        },
      ]
    },

    // Withdraws and Deposits
    {
      name: "CollaboratorBankOnline",
      path: "withdrawsAndDeposits",
      drawerLevel: "online",
      meta: {
        nameDrawer: messages[lang].depositsAndWithdrawals,
        icon: "mdi-bank-transfer",
        operator: operator.credit == 2 ? true : false,
        group: false,
        filterLimitDays: 31,
        permissions: ["5", "7", "63", "64"]
      },
      component: () =>
        import(
          "@/views/backoffice/collaborator/online/bankOnline/withdrawsAndDeposits"
        ),
      children: [
        // Tab - Extract
        {
          name: "CollaboratorAccountabilityOnlineBankStatement",
          path: "bankStatement",
          meta: {
            nameDrawer: messages[lang].extract,
            filters: ["Range", "PaymentProvider"],
            filterLimitDays: 31
          },
          component: () =>
            import(
              "@/views/backoffice/collaborator/online/bankOnline/bankStatement"
            ),
          beforeEnter: (to, from, next) => {
            const user_data = JSON.parse(localStorage.getItem("user_data"));
            const permissions = user_data.permissions;
            const hasPermission = id =>
              permissions.find(permission => permission.permissions == id);

            if (hasPermission("63")) {
              next();
            } else {
              next("/");
            }
          }
        },
        // Tab - By user - Extract Per user
        {
          name: "CollaboratorBankStatementByUser",
          path: "bankStatementByUser",
          meta: {
            nameDrawer: messages[lang].extractByUser,
            filters: ["Range", "PaymentProvider"],
            filterLimitDays: 31
          },
          component: () =>
            import(
              "@/views/backoffice/collaborator/online/bankOnline/bankStatementByUser"
            ),
          beforeEnter: (to, from, next) => {
            const user_data = JSON.parse(localStorage.getItem("user_data"));
            const permissions = user_data.permissions;
            const hasPermission = id =>
              permissions.find(permission => permission.permissions == id);

            if (hasPermission("64")) {
              next();
            } else {
              next("/");
            }
          }
        },
        // Tab - Deposits
        {
          name: "CollaboratorAccountabilityOnlineDeposits",
          path: "listDeposits",
          meta: {
            nameDrawer: messages[lang].deposits,
            filters: [
              "Range",
              "SelectTypeBankStatement",
              "PaymentProvider",
              "GroupExport"
            ],
            filterLimitDays: 31
          },
          component: () =>
            import(
              "@/views/backoffice/collaborator/online/bankOnline/listDeposits"
            ),
          beforeEnter: (to, from, next) => {
            const user_data = JSON.parse(localStorage.getItem("user_data"));
            const permissions = user_data.permissions;
            const hasPermission = id =>
              permissions.find(permission => permission.permissions == id);

            if (hasPermission("7")) {
              next();
            } else {
              next("/");
            }
          }
        },
        // Tab - Withdraws
        {
          name: "CollaboratorListWithdraws",
          path: "listWithdraws",
          meta: {
            nameDrawer: messages[lang].withdrawals,
            filters: [
              "Range",
              "SelectTypeBankStatement",
              "PaymentProvider",
              "GroupExport"
            ],
            filterLimitDays: 31
          },
          component: () =>
            import(
              "@/views/backoffice/collaborator/online/bankOnline/listWithdraws"
            ),
          beforeEnter: (to, from, next) => {
            const user_data = JSON.parse(localStorage.getItem("user_data"));
            const permissions = user_data.permissions;
            const hasPermission = id =>
              permissions.find(permission => permission.permissions == id);

            if (hasPermission("5")) {
              next();
            } else {
              next("/");
            }
          }
        }
      ]
    },

    // Bonus and Promotions
    {
      name: "CollaboratorBonusAndPromotions",
      path: "bonusAndPromotions",
      drawerLevel: "online",
      meta: {
        nameDrawer: messages[lang].PromotionsAndbonus,
        icon: "mdi-seal-variant",
        operator: operator.credit == 2 ? true : false,
        group: false,
        filterLimitDays: 31,
        permissions: ["8", "4"]
      },
      component: () =>
        import(
          "@/views/backoffice/collaborator/online/bonus/bonusAndPromotions"
        ),
      children: [
        {
          name: "CollaboratorListBonusOnline",
          path: "listBonusOnline",
          meta: {
            nameDrawer: messages[lang].bonus,

            icon: "mdi-seal-variant",
            operator: operator.credit == 2 ? true : false,
            group: false,
            filters: ["Range", "BonusReportType", "GroupExport", "SelectSport"],
            filterLimitDays: 31
          },
          component: () =>
            import(
              "@/views/backoffice/collaborator/online/bonus/listBonusOnline"
            )
        },
        {
          name: "CollaboratorListPromotionOnline",
          path: "listPromotionOnline",
          meta: {
            nameDrawer: messages[lang].promotions,
            operator: operator.credit == 2 ? true : false,
            filters: ["SelectStatus"]
          },
          component: () =>
            import(
              "@/views/backoffice/collaborator/online/bonus/listPromotionOnline"
            ),
          children: [
            {
              name: "CollaboratorListAdhesions",
              path: "listAdhesions",
              meta: {
                nameDrawer: messages[lang].adhesions,
                operator: operator.credit == 2 ? true : false
              },
              component: () =>
                import(
                  "@/views/backoffice/collaborator/online/bonus/dialogListAdhesions"
                )
            },
            {
              name: "CollaboratorExportPromotionTokens",
              path: "exportPromotionTokens",
              meta: {
                nameDrawer: messages[lang].exportTokens,
                operator: operator.credit == 2 ? true : false
              },
              component: () =>
                import(
                  "@/views/backoffice/collaborator/online/bonus/exportPromotionTokens"
                )
            }
          ]
        },
        {
          name: "CollaboratorFreespins",
          path: "freespins",
          meta: {
            nameDrawer: messages[lang].freespins.name,
            operator: operator.credit == 2 ? true : false,
            filters: ["SelectStatus"]
          },
          component: () =>
            import("@/views/backoffice/shared/bonusAndPromotions/freespins")
        }
      ]
    },

    //  =================================================================
    //  Group: Config Cassino
    //  =================================================================
    {
      name: "CollaboratorCasino",
      path: "casino",
      drawerLevel: "online",
      meta: {
        nameDrawer: messages[lang].casino,
        icon: "mdi-slot-machine-outline",
        operator:
          operator.credit == 2 && operator.casino != 0 && operatorHasNewCasino
            ? true
            : false,
        group: true,
        permissions: ["111"]
        // filterLimitDays: 31,
      },
      component: () =>
        import("@/views/backoffice/collaborator/online/casino/casino.vue"),
      children: [
        {
          name: "CollaboratorListCategories",
          path: "listCategories",
          meta: {
            nameDrawer: messages[lang].categories,
            hide: false,
            operator: operator.credit == 2 ? true : false,
            filters: ["SelectCasinoLobby"],
            permission: "111"
            // permissions: ["111", "112", "113", "114"],
          },
          component: () =>
            import(
              "@/views/backoffice/collaborator/online/casino/listCategories.vue"
            )
        },
        {
          name: "CollaboratorListGames",
          path: "listGames",
          meta: {
            nameDrawer: messages[lang].games,
            hide: false,
            operator: operator.credit == 2 ? true : false,
            filters: [
              "AutocompleteProvidersByOperator",
              "AutocompleteCasinoCategories",
              "SelectCasinoVerticalCategory",
              "SelectCasinoTheme",
              "SelectCasinoLobby"
            ],
            permission: "111"
            // permissions: ["111", "115", "112", "113", "114", "110", "116"],
          },
          component: () =>
            import(
              "@/views/backoffice/collaborator/online/casino/listGames.vue"
            )
        }
      ]
    },

    // Settings Online
    {
      name: "CollaboratorOperatorConfigOnline",
      path: "configOnline",
      drawerLevel: "online",
      meta: {
        nameDrawer: `${messages[lang].configuration} `,
        icon: "mdi-cog",
        operator: operator.credit == 2 ? true : false,
        group: true,
        permissions: ["10", "65", "67", "130"]
      },
      component: () =>
        import("@/views/backoffice/collaborator/online/settings/index"),
      children: [
        // General Settings
        {
          name: "ColabGeneralOnlineConfiguration",
          path: "general",
          meta: {
            nameDrawer: messages[lang].general,
            operator: operator.credit == 2,
            permission: "10"
          },
          component: () =>
            import(
              "@/views/backoffice/collaborator/online/settings/configOnline"
            )
        },
        // Payment Settings
        {
          name: "ColabPaymentProviderConfiguration",
          path: "paymentProviders",
          meta: {
            nameDrawer: messages[lang].payment,
            operator: operator.credit == 2,
            permission: "65"
          },
          component: () =>
            import(
              "@/views/backoffice/collaborator/online/settings/paymentProviders"
            ),
          beforeEnter: (to, from, next) => {
            const user_data = JSON.parse(localStorage.getItem("user_data"));
            const permissions = user_data.permissions;
            const hasPermission = id =>
              permissions.find(permission => permission.permissions == id);

            if (hasPermission("65")) {
              next();
            } else {
              next("/");
            }
          }
        },
        {
          name: "ColabWebhooks",
          path: "webhooks",
          meta: {
            nameDrawer: "Webhooks",
            operator: operator.credit == 2,
            permission: "130",
          },
          component: () =>
            import("@/views/backoffice/shared/webhooks"),
          beforeEnter: (to, from, next) => {
            const user_data = JSON.parse(localStorage.getItem("user_data"));
            const permissions = user_data.permissions;
            const hasPermission = id =>
              permissions.find(permission => permission.permissions == id);

            if (hasPermission("130")) {
              next();
            } else {
              next("/");
            }
          }
        },
        // Casino Settings
        {
          name: "ColabCasinoSettings",
          path: "casinoSettings",
          meta: {
            nameDrawer: messages[lang].casino,
            operator: operator.casino != 0 && !operatorHasNewCasino,
            permission: "67"
          },
          component: () =>
            import("@/views/backoffice/collaborator/settings/casino.vue"),
          beforeEnter: (to, from, next) => {
            const user_data = JSON.parse(localStorage.getItem("user_data"));
            const permissions = user_data.permissions;
            const hasPermission = id =>
              permissions.find(permission => permission.permissions == id);

            if (hasPermission("67")) {
              next();
            } else {
              next("/");
            }
          }
        }
      ]
    },

    // Documents
    {
      name: "DocumentsCollaborator",
      path: "documents",
      drawerLevel: "online",
      meta: {
        nameDrawer: messages[lang].documents,
        operator: operator.credit == 2,
        group: false,
        icon: "mdi-file-document",
        permissions: ["3"]
      },
      component: () =>
        import("@/views/backoffice/collaborator/online/documents.vue")
    },

    //  =================================================================
    //  Category: Operation
    //  =================================================================

    // Reports
    {
      name: "CollaboratorReports",
      path: "reports",
      drawerLevel: "operation",
      meta: {
        nameDrawer: messages[lang].reports,
        operator: true,
        icon: "mdi-chart-bar",
        group: true,
        permissions: ["71", "73"]
      },
      //Index (router-view)
      component: () => import("@/views/backoffice/collaborator"),
      children: [
        {
          name: "ColabReportsBetList",
          path: "list",
          meta: {
            nameDrawer: messages[lang].eventsBetting,
            operator: true,
            permission: "71",
            showMenu: true
          },
          component: () =>
            import("@/views/backoffice/collaborator/reports/reportBetEvents"),
          beforeEnter: (to, from, next) => {
            const user_data = JSON.parse(localStorage.getItem("user_data"));
            const permissions = user_data.permissions;
            const hasPermission = id =>
              permissions.find(permission => permission.permissions == id);

            if (hasPermission("71")) {
              next();
            } else {
              next("/");
            }
          }
        },
        {
          name: "ColabReportDefends",
          path: "defends",
          meta: {
            nameDrawer: messages[lang].defense,
            operator: true,
            permission: "73",
            showMenu: true
          },
          component: () =>
            import("@/views/backoffice/collaborator/reports/defends"),
          beforeEnter: (to, from, next) => {
            const user_data = JSON.parse(localStorage.getItem("user_data"));
            const permissions = user_data.permissions;
            const hasPermission = id =>
              permissions.find(permission => permission.permissions == id);

            if (hasPermission("73")) {
              next();
            } else {
              next("/");
            }
          }
        },
        {
          name: "ColabReportsUsers",
          path: "reportUsers",
          meta: {
            nameDrawer: messages[lang].users,
            operator: true,
            hide: operator.credit != 2,
            permission: "146",
            showMenu: true,
            filters: ["Range", "GroupExport"],
            filterLimitDays: 31,
          },
          component: () =>
            import("@/views/backoffice/shared/reports/users"),
          beforeEnter: (to, from, next) => {
            const user_data = JSON.parse(localStorage.getItem("user_data"));
            const permissions = user_data.permissions;
            const hasPermission = id =>
              permissions.find(permission => permission.permissions == id);

            if (hasPermission("146")) {
              next();
            } else {
              next("/");
            }
          }
        },
        {
          name: "ColabReportsSportBets",
          path: "reportSportBets",
          meta: {
            nameDrawer: messages[lang].bets,
            operator: true,
            hide: operator.credit != 2,
            permission: "147",
            showMenu: true,
            filters: ["Range", "GroupExport"],
            filterLimitDays: 15,
          },
          component: () =>
            import("@/views/backoffice/shared/reports/sportsbookBet"),
          beforeEnter: (to, from, next) => {
            const user_data = JSON.parse(localStorage.getItem("user_data"));
            const permissions = user_data.permissions;
            const hasPermission = id =>
              permissions.find(permission => permission.permissions == id);

            if (hasPermission("147")) {
              next();
            } else {
              next("/");
            }
          }
        },
        {
          name: "ColabReportsCasinoBets",
          path: "reportCasinoBets",
          meta: {
            nameDrawer: messages[lang].casino,
            operator: operator.credit == 2,
            permission: "151",
            showMenu: operator.credit == 2,
            filters: ["Range", "GroupExport"],
            filterLimitDays: 31,
          },
          component: () =>
            import("@/views/backoffice/shared/reports/casinoBet"),
          beforeEnter: (to, from, next) => {
            const user_data = JSON.parse(localStorage.getItem("user_data"));
            const permissions = user_data.permissions;
            const hasPermission = id =>
              permissions.find(permission => permission.permissions == id);

              if (hasPermission("151") && operator.credit == 2) {
              next();
            } else {
              next("/");
            }
          }
        },
        {
          name: "ColabReportsDeposits",
          path: "reportDeposits",
          meta: {
            nameDrawer: messages[lang].deposits,
            operator: true,
            hide: operator.credit != 2,
            permission: "148",
            showMenu: true,
            filters: ["Range", "GroupExport"],
            filterLimitDays: 31,
          },
          component: () =>
            import("@/views/backoffice/shared/reports/deposits"),
          beforeEnter: (to, from, next) => {
            const user_data = JSON.parse(localStorage.getItem("user_data"));
            const permissions = user_data.permissions;
            const hasPermission = id =>
              permissions.find(permission => permission.permissions == id);

            if (hasPermission("148")) {
              next();
            } else {
              next("/");
            }
          }
        },
        {
          name: "ColabReportsWithdrawals",
          path: "reportWithdrawals",
          meta: {
            nameDrawer: messages[lang].withdrawals,
            operator: true,
            hide: operator.credit != 2,
            permission: "149",
            showMenu: true,
            filters: ["Range", "GroupExport"],
            filterLimitDays: 31,
          },
          component: () =>
            import("@/views/backoffice/shared/reports/withdrawals"),
          beforeEnter: (to, from, next) => {
            const user_data = JSON.parse(localStorage.getItem("user_data"));
            const permissions = user_data.permissions;
            const hasPermission = id =>
              permissions.find(permission => permission.permissions == id);

            if (hasPermission("149")) {
              next();
            } else {
              next("/");
            }
          }
        },
      ]
    },

    // Events
    {
      name: "CollaboratorEvents",
      path: "events",
      drawerLevel: "operation",
      meta: {
        nameDrawer: messages[lang].events,
        operator: true,
        icon: "mdi-trophy-outline",
        group: true,
        permissions: ["76", "57"]
      },
      //Index (router-view)
      component: () => import("@/views/backoffice/collaborator"),
      children: [
        {
          name: "CollaboratorEventsList",
          path: "list",
          meta: {
            nameDrawer: messages[lang].events,
            operator:
              operator.operatorType == 1 || operator.operatorType == 2
                ? true
                : false,
            permissions: ["76"]
            // filters: ["SelectStatusEvents",]
          },
          component: () =>
            import("@/views/backoffice/collaborator/events/list"),
          children: [
            {
              name: "CollaboratorEventEditOdds",
              path: "event/:id",
              meta: {
                nameDrawer: messages[lang].editOdd
              },
              component: () =>
                import("@/views/backoffice/collaborator/events/editOdds")
            },
            {
              name: "CollaboratorBetPlacedReport",
              path: "betPlacedReport",
              meta: {
                nameDrawer: messages[lang].betPlacedReport
              },
              component: () =>
                import("@/views/backoffice/collaborator/events/betPlacedReport")
            },
            {
              name: "CollaboratorMarketReportByEvent",
              path: "event/:id",
              component: () =>
                import(
                  "@/views/backoffice/collaborator/events/marketReportByEvent"
                )
            }
          ],
          beforeEnter: (to, from, next) => {
            const user_data = JSON.parse(localStorage.getItem("user_data"));
            const permissions = user_data.permissions;
            const hasPermission = id =>
              permissions.find(permission => permission.permissions == id);

            if (hasPermission("76")) {
              next();
            } else {
              next("/");
            }
          }
        },
        {
          name: "CollaboratorMainEvents",
          path: "mainEvents",
          meta: {
            nameDrawer: messages[lang].mainEvents,
            operator: operator.credit == 2,
            permission: "57",
            showMenu: true
          },
          component: () =>
            import("@/views/backoffice/collaborator/events/mainEvents"),
          beforeEnter: (to, from, next) => {
            const user_data = JSON.parse(localStorage.getItem("user_data"));
            const permissions = user_data.permissions;
            const hasPermission = id =>
              permissions.find(permission => permission.permissions == id);

            if (hasPermission("57")) {
              next();
            } else {
              next("/");
            }
          }
        }

        // {
        //   name: "CollaboratorCreatedEvents",
        //   path: "createdEvents",
        //   meta: {
        //     nameDrawer: messages[lang].createNewEvent.drawer,
        //     operator: operator.credit == 2,
        //     permission: "57",
        //     showMenu: true,
        //   },
        //   component: () =>
        //     import("@/views/backoffice/shared/events/createdEvents/list"),
        //   beforeEnter: (to, from, next) => {
        //     const user_data = JSON.parse(localStorage.getItem("user_data"));
        //     const permissions = user_data.permissions;
        //     const hasPermission = (id) =>
        //       permissions.find((permission) => permission.permissions == id);

        //     if (hasPermission("57")) {
        //       next();
        //     } else {
        //       next("/");
        //     }
        //   },
        // },
      ]
    },

    // Settings Operation
    {
      name: "CollaboratorSettings",
      path: "settings",
      drawerLevel: "operation",
      meta: {
        nameDrawer: messages[lang].configuration,
        operator: true,
        group: true,
        icon: "mdi-wrench",
        permissions: ["85", "87", "42", "44", "45", "46", "47"]
      },
      //Index (router-view)
      component: () => import("@/views/backoffice/administrator"),
      children: [
        {
          name: "CollaboratorSettingsInstitutional",
          path: "institutional",
          meta: {
            nameDrawer: messages[lang].institutional,
            operator: true,
            permission: "85",
            showMenu: true
          },
          component: () =>
            import(
              "@/views/backoffice/collaborator/settings/institutional.vue"
            ),
          beforeEnter: (to, from, next) => {
            const user_data = JSON.parse(localStorage.getItem("user_data"));
            const permissions = user_data.permissions;
            const hasPermission = id =>
              permissions.find(permission => permission.permissions == id);

            if (hasPermission("85")) {
              next();
            } else {
              next("/");
            }
          }
        },
        {
          name: "CollaboratorSettingsBank",
          path: "bank",
          meta: {
            nameDrawer: messages[lang].bankConfiguration,
            operator: true,
            permission: "87",
            showMenu: true
          },
          component: () =>
            import("@/views/backoffice/collaborator/settings/bank.vue"),
          beforeEnter: (to, from, next) => {
            const user_data = JSON.parse(localStorage.getItem("user_data"));
            const permissions = user_data.permissions;
            const hasPermission = id =>
              permissions.find(permission => permission.permissions == id);

            if (hasPermission("87")) {
              next();
            } else {
              next("/");
            }
          }
        },
        {
          name: "CollaboratorSettingsLeagues",
          path: "leagues",
          meta: {
            nameDrawer: messages[lang].manageLeagues,
            operator: true,
            permissions: ["42"]
          },
          component: () =>
            import("@/views/backoffice/collaborator/operation/leagues.vue"),
          beforeEnter: (to, from, next) => {
            const user_data = JSON.parse(localStorage.getItem("user_data"));
            const permissions = user_data.permissions;
            const hasPermission = id =>
              permissions.find(permission => permission.permissions == id);

            if (hasPermission("42")) {
              next();
            } else {
              next("/");
            }
          }
        },
        {
          name: "CollaboratorSettingsMarketsMargins",
          path: "markets-margin",
          meta: {
            nameDrawer: messages[lang].marketsAndMargins,
            operator: true,
            permissions: ["46"]
          },
          component: () =>
            import(
              "@/views/backoffice/collaborator/operation/markets-margin.vue"
            )
        },
        // {
        //   name: "CollaboratorSettingsMedia",
        //   path: "media-settings",
        //   meta: {
        //     nameDrawer: messages[lang].manageMedia,
        //     operator: true,
        //     hide: true,
        //     subGroup: true,
        //     permissions: ["44", "45"]
        //   },
        //   component: () =>
        //     import(
        //       "@/views/backoffice/administrator/settings/mediaSettings.vue"
        //     ),
        //   children: [
        //     {
        //       name: "CollaboratorMedia",
        //       path: "media",
        //       meta: {
        //         nameDrawer: messages[lang].medias,
        //         operator: true,
        //         permission: "44"
        //       },
        //       component: () =>
        //         import("@/views/backoffice/administrator/settings/media.vue"),
        //       beforeEnter: (to, from, next) => {
        //         const user_data = JSON.parse(localStorage.getItem("user_data"));
        //         const permissions = user_data.permissions;
        //         const hasPermission = id =>
        //           permissions.find(permission => permission.permissions == id);

        //         if (hasPermission("44")) {
        //           next();
        //         } else {
        //           next("/");
        //         }
        //       }
        //     },
        //     {
        //       name: "CollaboratorLandingPage",
        //       path: "landing-page",
        //       meta: {
        //         nameDrawer: messages[lang].landingPage,
        //         operator:
        //           operator.operatorType == 2 || operator.operatorType == 1,
        //         permission: "45"
        //       },
        //       component: () =>
        //         import(
        //           "@/views/backoffice/administrator/settings/landingPage.vue"
        //         ),
        //       beforeEnter: (to, from, next) => {
        //         const user_data = JSON.parse(localStorage.getItem("user_data"));
        //         const permissions = user_data.permissions;
        //         const hasPermission = id =>
        //           permissions.find(permission => permission.permissions == id);

        //         if (hasPermission("45")) {
        //           next();
        //         } else {
        //           next("/");
        //         }
        //       }
        //     }
        //   ]
        // },

        // Notifications
        {
          name: "CollaboratorNotifications",
          path: "notifications/list",
          drawerLevel: "operation",
          meta: {
            nameDrawer: messages[lang].notifications,
            icon: "mdi-account",
            operator: operator.credit == 2 ? true : false,
            permissions: [
              "156",
            ],
            filters: ["Range"],
            filterLimitDays: 31
          },
          component: () =>
            import("@/views/backoffice/collaborator/notifications/usersNotifications/"),

          beforeEnter: (to, from, next) => {
            const user_data = JSON.parse(localStorage.getItem("user_data"));
            const permissions = user_data.permissions;
            const hasPermission = id =>
              permissions.find(permission => permission.permissions == id);

            if (hasPermission("156")) {
              next();
            } else {
              next("/");
            }
          },

          children: [
            // Players (Jogadores) Online
            {
              name: "CollaboratorFinalUserNotifications",
              path: "new-notification",
              meta: {
                nameDrawer: messages[lang].notifications,
                operator: true,
                // operator: operator.credit == 2 ? true : false,
                // filters: ["Range"],
              },
              component: () =>
                import(
                  "@/views/backoffice/collaborator/notifications/usersNotifications/"
                ),
              children: [
                {
                  name: "CollaboratorFinalUserNotificationAdd",
                  path: "add",
                  meta: {
                    nameDrawer: messages[lang].newMessage,
                    hide: true,
                  },
                  component: () =>
                  import(
                    "@/views/backoffice/collaborator/notifications/usersNotifications/addNotification.vue"
                  ),
                },
                {
                  name: "CollaboratorFinalUserNotificationSee",
                  path: "see-message",
                  meta: { nameDrawer: messages[lang].seeNotification },
                  component: () => import(
                    '@/views/backoffice/collaborator/notifications/usersNotifications/seeNotification.vue'
                  ),
                },
                {
                  name: "CollaboratorFinalUserNotificationDelete",
                  path: "delete",
                  meta: {
                    nameDrawer: messages[lang].deleteMessage,
                    hide: true,
                  },
                  component: () =>
                  import(
                    "@/views/backoffice/collaborator/notifications/usersNotifications/deleteNotification.vue"
                  ),
                },
              ]
            },
          ]
        },
      ]
    },

    {
      name: "CollaboratorAccount",
      path: "account",
      meta: {
        nameDrawer: messages[lang].account,
        operator: true,
        icon: "mdi-badge-account-horizontal",
        group: true
      },
      component: () => import("@/views/backoffice/collaborator"),
      children: [
        {
          name: "CollaboratorAccountChangePassword",
          path: "changePassword",
          meta: {
            nameDrawer: messages[lang].changePassword,
            operator: true
          },
          component: () =>
            import("@/views/backoffice/shared/account/changePassword.vue")
        }
      ]
    }
  ]
};
